import {
  TRAVAUX_ESSENCE_DETAIL_ROWS,
  formatValueWithSujetLabel,
  isNonEmptyTravauxValue,
  type TravauxEssenceWebProp,
} from '../essence-intervention-display';

interface EssenceInterventionSectionProps {
  readonly index: number;
  readonly travauxDescription: string;
  readonly defautsMecaniques: string;
  readonly proximiteDirecte: string;
  readonly nuisancesConstatees: string;
  readonly travauxAbattage?: string | null;
  readonly travauxDemontage?: string | null;
  readonly travauxMiseEnSecurite?: string | null;
  readonly travauxTailleSanitaire?: string | null;
  readonly travauxDechiffrage?: string | null;
  readonly travauxCoupleSelective?: string | null;
}

export default function EssenceInterventionSection({
  index,
  travauxDescription,
  defautsMecaniques,
  proximiteDirecte,
  nuisancesConstatees,
  travauxAbattage,
  travauxDemontage,
  travauxMiseEnSecurite,
  travauxTailleSanitaire,
  travauxDechiffrage,
  travauxCoupleSelective,
}: EssenceInterventionSectionProps) {
  const essenceIndex = index + 1;

  const travauxDetailValues: Record<TravauxEssenceWebProp, string | null | undefined> =
  {
    travauxAbattage,
    travauxDemontage,
    travauxMiseEnSecurite,
    travauxTailleSanitaire,
    travauxDechiffrage,
    travauxCoupleSelective,
  };

  const visibleTravauxDetails = TRAVAUX_ESSENCE_DETAIL_ROWS.filter((row) =>
    isNonEmptyTravauxValue(travauxDetailValues[row.webProp])
  );

  return (
    <div className="mb-8">
      <div className="bg-black text-white text-center font-bold py-2 text-lg">
        ESSENCE {essenceIndex}
      </div>

      <div className="border-2 border-black p-4 mt-2">

        <div className="space-y-2 text-sm">

          {visibleTravauxDetails?.length > 0 ? visibleTravauxDetails.map((row) => (
            <div key={row.webProp} className="flex items-baseline">
              <span className="font-semibold mr-2">{row.label}</span>
              <span className="border-b border-black flex-1">
                {formatValueWithSujetLabel(
                  String(travauxDetailValues[row.webProp] ?? '')
                )}
              </span>
            </div>
          )) : (
            <div className="flex items-baseline justify-center">
              <span className="font-semibold mr-2">Aucun travaux</span>
            </div>
          )}

        </div>

      </div>


    </div>
  );
}
